import { render, staticRenderFns } from "./FormCollaborationModal.vue?vue&type=template&id=b1f46652&"
import script from "./FormCollaborationModal.vue?vue&type=script&lang=js&"
export * from "./FormCollaborationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports